<template>
  <nav>
    <SbSelect
      :input-id="inputId"
      :data-testid="`${inputId}-select`"
      :options="options"
      :model-value="modelValue"
      :hidden-label="hiddenLabel"
      inline
      disable-filter
      infinite-scroll
      :labeled-by="labeledBy"
      :navigational-select="navigationalSelect"
      @update:model-value="onChange"
      @load-more="emit('load-more')"
    />
  </nav>
</template>

<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import SbSelect from '../../Select'
import type { SelectOptionObject } from '../utils'

export type SbPaginationSelectProps = {
  options: SelectOptionObject[]
  modelValue?: number
  inputId?: string
  navigationalSelect?: boolean
  labeledBy?: string
  hiddenLabel?: string
  // eslint-disable-next-line vue/prop-name-casing
} & /* @vue-ignore */ Pick<HTMLAttributes, 'aria-label'>

withDefaults(defineProps<SbPaginationSelectProps>(), {
  modelValue: 1,
  inputId: '',
  navigationalSelect: false,
})

const emit = defineEmits<{
  (e: 'change', value: number): void
  (e: 'load-more'): void
}>()

function onChange(value: number) {
  emit('change', value)
}
</script>
